module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0005.jpg?v=c23f1664";